import React, { createContext, PropsWithChildren, useMemo } from "react"

import { useConfigContext } from "@providers/config"

import { GridItem } from "@chakra-ui/react"
import Link from "@components/Link"

export interface LearnPageProps extends PropsWithChildren {
  item: NormalisedArticle
  handleTrackingClick?: VoidFunction
}

export const LearnPageContext = createContext<Omit<LearnPageProps, "children">>({
  item: {} as NormalisedArticle,
  handleTrackingClick: undefined,
})

const LearnPage = ({ item, handleTrackingClick, children }: LearnPageProps) => {
  const {
    settings: { routes },
  } = useConfigContext()

  const url = useMemo(() => {
    if (item?.link?.url) {
      // check if url starts with /article/ and if so, remove it
      if (item?.link?.url?.includes(routes.ARTICLE)) return item?.link?.url
      return `${routes.ARTICLE}${item?.link.url}`
    }
    if (item?.handle?.current) {
      if (item?.handle?.current?.includes(routes.ARTICLE)) return item?.handle?.current
      return `${routes.ARTICLE}/${item?.handle?.current}`
    }
    return ""
  }, [item?.handle?.current, item?.link?.url, routes.ARTICLE])

  return (
    <LearnPageContext.Provider value={{ item, handleTrackingClick }}>
      <GridItem as="article">
        <Link title={item?.title} to={url} onClick={handleTrackingClick} height={`full`} display={`block`}>
          {children}
        </Link>
      </GridItem>
    </LearnPageContext.Provider>
  )
}

export default React.memo(LearnPage)
